
function EMAChangeRequest(aEMAChangeRequest) {
    "use strict";

    this.__type = 'EMAChangeRequest:www.veritracks.com';
    this.Id = 0;
    this.EnrolleeId = -1
    this.EMAUserId = "",
    this.ChangeReqTypeId = "";
    this.ChangeReqNewValue = ""; 
    this.ChangeRequestKeyValue = ""; 
    this.ZoneName = ""; 
    this.ZoneId = 0; 
    this.Description = ""; 
    this.AgentDecision = 0;
    this.AppUserId = "";
    this.StartDate = new Date("01 Jan 2001 6:00 AM");
    this.StopDate = new Date("01 Jan 2001 8:00 PM");
    this.ActionId = -1;
    this.UserId = 0;
    this.AgentNotes="";
    this.CheckInRequired = 0;
    if(aEMAChangeRequest && typeof aEMAChangeRequest !== "undefined" && aEMAChangeRequest !=null){
        for(var i in aEMAChangeRequest){
            this[i] = aEMAChangeRequest[i];
        }
    }
}
if (typeof exports !== 'undefined') {
    module.exports = EMAChangeRequest;
}